export default "__VITE_ASSET__Bij_5OFd__"